import React, { useState, useEffect, useRef } from 'react';
import '../styles/AreaCliente.css';
import Calendario from '../components/Calendario/Calendario';
import InputDocs from '../components/InputDocs/InputDocs';
import Inbox from '../components/Inbox/Inbox';
import { db, auth } from '../firebase/firebaseConfig';
import { collection, query, onSnapshot, doc, setDoc } from 'firebase/firestore';
import bgShapes from '../assets/BG-shapes-1.png';
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBriefcase,
    faCalendarCheck,
    faChevronDown,
    faCopy,
    faEnvelopeOpenText,
    faFileArrowUp,
    faFingerprint,
    faIdCard,
    faLink,
    faUserCheck,
} from '@fortawesome/free-solid-svg-icons';

const AreaAdvogado = () => {
    const menuRef = useRef(null);
    const [menuAberto, setMenuAberto] = useState(false);
    const [clienteSelecionado, setClienteSelecionado] = useState(() => {
        const clienteSalvo = sessionStorage.getItem('clienteSelecionado');
        return clienteSalvo ? JSON.parse(clienteSalvo) : null;
    });
    const [clientes, setClientes] = useState([]);
    const [linkGerado, setLinkGerado] = useState('');
    const userEmail = auth.currentUser?.email;

    const selecionarCliente = (cliente) => {
        setClienteSelecionado(cliente);
        setLinkGerado('');
        setMenuAberto(false);
        sessionStorage.setItem('clienteSelecionado', JSON.stringify(cliente));
    };

    const gerarLinkParaCliente = async (clienteId) => {
        try {
            const token = uuidv4();
            const expiracao = Date.now() + 14400 * 1000;

            await setDoc(doc(db, 'tokens', token), {
                clienteId,
                userEmail,
                expiracao,
            });

            const link = `${process.env.REACT_APP_URL_FRONT}/cliente/${token}`;
            setLinkGerado(link);
        } catch (error) {
            console.error('Erro ao gerar link para cliente:', error);
        }
    };

    useEffect(() => {
        if (!userEmail) return undefined;

        const clientesRef = collection(db, `usuarios/${userEmail}/clientes`);
        const q = query(clientesRef);

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const listaClientes = snapshot.docs.map((clienteDoc) => ({
                id: clienteDoc.id,
                ...clienteDoc.data(),
            }));
            setClientes(listaClientes);
        });

        return () => unsubscribe();
    }, [userEmail]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuAberto && menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuAberto(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuAberto]);

    const renderMenuClientes = (extraClass = '') => (
        menuAberto && (
            <div ref={menuRef} className={`menu-clientes ${extraClass}`}>
                {clientes.length > 0 ? (
                    clientes.map((cliente) => (
                        <button
                            key={cliente.id}
                            className="item-cliente"
                            onClick={() => selecionarCliente(cliente)}
                            type="button"
                        >
                            {cliente.nome || 'Cliente sem nome'}
                        </button>
                    ))
                ) : (
                    <div className="item-cliente item-cliente-vazio">Nenhum cliente encontrado</div>
                )}
            </div>
        )
    );

    return (
        <main className="main-container-areacliente">
            <img className="bgshapes" src={bgShapes} alt="bgShapes" />
            <div className={`container-areacliente ${clienteSelecionado ? '' : 'centralizada'}`}>
                {clienteSelecionado ? (
                    <>
                        <section className="area-cliente-adv-header">
                            <div className="area-cliente-adv-title">
                                <span className="area-cliente-kicker">Area do cliente</span>
                                <h1>{clienteSelecionado.nome || 'Cliente selecionado'}</h1>
                                <p>Agenda, documentos e mensagens do atendimento reunidos em uma visao unica.</p>
                            </div>

                            <div className="area-cliente-adv-actions">
                                <button
                                    onClick={() => setMenuAberto(true)}
                                    className="area-cliente-secondary-btn"
                                    type="button"
                                >
                                    <FontAwesomeIcon icon={faUserCheck} />
                                    <span>Trocar cliente</span>
                                    <FontAwesomeIcon icon={faChevronDown} />
                                </button>
                                <button
                                    className="area-cliente-primary-btn"
                                    onClick={() => gerarLinkParaCliente(clienteSelecionado.id)}
                                    type="button"
                                >
                                    <FontAwesomeIcon icon={faLink} />
                                    <span>Gerar link</span>
                                </button>
                                {renderMenuClientes('area-cliente-menu-dropdown')}
                            </div>
                        </section>

                        <section className="area-cliente-stats area-cliente-client-summary" aria-label="Resumo do cliente">
                            <div className="area-cliente-stat">
                                <FontAwesomeIcon icon={faIdCard} />
                                <div>
                                    <span>{clienteSelecionado.nome || 'Cliente'}</span>
                                    <p>Cliente selecionado</p>
                                </div>
                            </div>
                            <div className="area-cliente-stat">
                                <FontAwesomeIcon icon={faFingerprint} />
                                <div>
                                    <span>{clienteSelecionado.cpf || 'CPF nao informado'}</span>
                                    <p>CPF</p>
                                </div>
                            </div>
                            <div className="area-cliente-stat">
                                <FontAwesomeIcon icon={faBriefcase} />
                                <div>
                                    <span>{clienteSelecionado.processo || 'Processo nao informado'}</span>
                                    <p>Processo</p>
                                </div>
                            </div>
                            <div className="area-cliente-stat">
                                <FontAwesomeIcon icon={faLink} />
                                <div>
                                    <span>{linkGerado ? 'Link gerado' : 'Link pendente'}</span>
                                    <p>Acesso externo</p>
                                </div>
                            </div>
                        </section>

                        {linkGerado && (
                            <section className="area-cliente-link-card">
                                <FontAwesomeIcon icon={faCopy} />
                                <div>
                                    <span>Link gerado para o cliente</span>
                                    <a href={linkGerado} target="_blank" rel="noopener noreferrer">{linkGerado}</a>
                                </div>
                            </section>
                        )}

                        <section className="area-cliente-workspace area-cliente-adv-workspace">
                            <article className="area-cliente-panel area-cliente-panel-calendar">
                                <div className="area-cliente-panel-header">
                                    <div>
                                        <span>Calendario</span>
                                        <p>Prazos e compromissos do cliente.</p>
                                    </div>
                                    <FontAwesomeIcon icon={faCalendarCheck} />
                                </div>
                                <Calendario />
                            </article>

                            <article className="area-cliente-panel area-cliente-panel-docs">
                                <div className="area-cliente-panel-header">
                                    <div>
                                        <span>Documentos</span>
                                        <p>Arquivos enviados e visualizacao rapida.</p>
                                    </div>
                                    <FontAwesomeIcon icon={faFileArrowUp} />
                                </div>
                                <InputDocs />
                            </article>

                            <article className="area-cliente-panel area-cliente-panel-inbox">
                                <div className="area-cliente-panel-header">
                                    <div>
                                        <span>Inbox</span>
                                        <p>Mensagens trocadas com este cliente.</p>
                                    </div>
                                    <FontAwesomeIcon icon={faEnvelopeOpenText} />
                                </div>
                                <Inbox />
                            </article>
                        </section>
                    </>
                ) : (
                    <section className="area-cliente-empty-state">
                        <span className="area-cliente-kicker">Area do cliente</span>
                        <h1>Selecione um cliente.</h1>
                        <p>Escolha um cadastro para abrir agenda, documentos, mensagens e gerar o link de acesso externo.</p>
                        <button onClick={() => setMenuAberto(true)} className="area-cliente-primary-btn" type="button">
                            <FontAwesomeIcon icon={faUserCheck} />
                            <span>Selecionar cliente</span>
                        </button>
                        {renderMenuClientes('centralizada')}
                    </section>
                )}
            </div>
        </main>
    );
};

export default AreaAdvogado;
